import EligibleTab from './EligibleTab';
import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import {
  returnIsPendingSel,
  partsToReturnSel,
  returnAlertSel,
  returnsActions
} from 'src/store/modules/returns';
import { withI18n } from 'react-i18next';

const mapStateToProps = (state: IInitialState) => ({
  partsToReturn: partsToReturnSel(state),
  returnIsPending: returnIsPendingSel(state),
  returnAlert: returnAlertSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({
  closeAlert: () => {
    dispatch(
      returnsActions.setReturnAlert({
        show: false,
        message: '',
        type: '',
        icon: ''
      })
    );
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(EligibleTab));
